var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37765 4.84348C7.50799 4.84348 7.59487 4.84348 7.7252 4.84348C8.59408 4.88857 9.15885 5.5199 9.15885 6.46689C9.15885 7.95502 9.15885 8.63144 9.15885 10.1647C9.15885 11.1567 8.55064 11.8332 7.63832 11.8332C5.59645 11.8332 3.55459 11.8332 1.51272 11.8332C0.600402 11.8332 -0.0078125 11.1567 -0.0078125 10.1196C-0.0078125 8.67653 -0.0078125 8.04521 -0.0078125 6.60217C-0.0078125 5.4748 0.556958 4.84348 1.59961 4.79838C1.64306 4.79838 1.6865 4.79838 1.77339 4.79838C1.77339 4.34743 1.77339 3.89649 1.77339 3.44554C1.77339 2.85931 1.86028 2.27307 2.16438 1.73194C2.72915 0.604566 3.8587 0.0183334 5.07513 0.198713C6.16122 0.424187 7.07355 1.37118 7.29077 2.63383C7.33421 2.9495 7.33421 3.26516 7.33421 3.58082C7.37765 4.03177 7.37765 4.43762 7.37765 4.84348ZM6.63911 4.84348C6.63911 4.16705 6.68255 3.49063 6.63911 2.85931C6.55222 2.09269 6.16122 1.50646 5.50957 1.1908C4.51035 0.694755 3.20704 1.01042 2.68571 2.27307C2.33816 3.08478 2.51193 3.98668 2.46849 4.84348C3.8587 4.84348 5.2489 4.84348 6.63911 4.84348Z",
    fill: "#4AC600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cec384c3.svg";
export { ForwardRef as ReactComponent };